import { render, staticRenderFns } from "./SearchPage.vue?vue&type=template&id=ddde0062&lang=pug&"
import script from "./SearchPage.vue?vue&type=script&lang=ts&"
export * from "./SearchPage.vue?vue&type=script&lang=ts&"
import style0 from "./SearchPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports